const colors = require("../../src/styles/colors");

module.exports = {
  siteTitle: "Jordan Chun", // <title>
  shortSiteTitle: "Jordan Chun Portfolio", // <title> ending for posts and pages
  siteDescription: "Jordan Chun Portfolio",
  siteUrl: "https://gatsby-starter-personal-blog.greglobinski.com",
  pathPrefix: "",
  siteImage: "preview.jpg",
  siteLanguage: "en",
  // author
  authorName: "Jordan Chun",
  authorTwitterAccount: "jchun765",
  // info
  infoTitle: "jordan chun",
  infoTitleNote: "software engineer",
  // manifest.json
  manifestName: "Jordan Chun Portfolio",
  manifestShortName: "Portfolio", // max 12 characters
  manifestStartUrl: "/",
  manifestBackgroundColor: colors.background,
  manifestThemeColor: colors.background,
  manifestDisplay: "standalone",
  // contact
  contactEmail: "jchun765@gmail.com",
  // social
  authorSocialLinks: [
    { name: "github", url: "https://github.com/jchun765" },
    // { name: "linkedIn", url: "https://twitter.com/greglobinski" },
    // { name: "facebook", url: "https://facebook.com/greglobinski" }
    { name: "linkedin", url: "https://www.linkedin.com/in/jordanchun/" },
  ]
};



// WEBPACK FOOTER //
// ./content/meta/config.js